import request from "./api";
/**
 *    noteApi   学习中心笔记api
 * */
// 获取所有的章节目录
export const getCatalogList = (courseId, params, opts) =>
    request('/api-course/catalog/catalog/'+courseId, params, {
        ...opts
    });
// 添加笔记
export const addNote = (params, opts) =>
    request('/api-study/stuNote', params, {
        ...opts,
        method: 'post'
    });
// 编辑笔记
export const editorNote = (params, opts) =>
    request('/api-study/stuNote', params, {
        ...opts,
        method: 'put'
    });
// 获取我的笔记
export const getMyNote = (params, opts) =>
    request('/api-study/myStuNote', params, {
        ...opts,
        method: 'post'
    });
// 删除笔记
export const delNote = (id, params, opts) =>
    request('/api-study/stuNote?id='+id, params, {
        ...opts,
        method: 'delete'
    });
// 笔记点赞
export const likeIfNote = (params, opts) =>
    request('/api-study/notePraise', params, {
        ...opts,
        method: 'post'
    });
// 获取笔记评论
export const getNoteReply = (id, params, opts) =>
    request('/api-study/noteReply?id='+id, params, {
        ...opts
    });
// 发表评论
export const publishReply = (params, opts) =>
    request('/api-study/noteReply', params, {
        ...opts,
         method: 'post'
    });
// 删除评论
export const delReply = (learnId, id, params, opts) =>
    request('/api-study/noteReply?learnId='+learnId+'&replyId='+id, params, {
        ...opts,
         method: 'delete'
    });
// 获取同学笔记
export const getClassNote = (params, opts) =>
    request('/api-study/classStuNote', params, {
        ...opts,
         method: 'post'
    });


// WEBPACK FOOTER //
// ./src/api/noteApi.js